import Col from 'react-bootstrap/Col';
import Row from 'react-bootstrap/Row';
// import { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import ContactForm from '../components/contact/contact-form';
import ContactAddress from '../components/contact/contact-address-text';
import ContactPhone from '../components/contact/contact-phone';
import ContactEmail from '../components/contact/contact-email';
import Map from '../map-comp';
import LogoComponent from '../components/logo-comp';

const ContactPage = () => {
    const { t, i18n } = useTranslation();      
    const contactUsLbl = i18n.exists("forms.contactUs") ? t('forms.contactUs') : "Връзка с нас"; 

    // useEffect(() => {

    // }, [])

    return (
        <div className="pg-form contact-page">
        <Row className="mb-3">
            {/* <Col md="6" className="margin-0 form-bg-out">
                <div className="form-bg"></div>
            </Col> */}
            <Col md="12" className="margin-0 bl-form-out">
                <div className='mobile-contact-head'>
                    <LogoComponent logoColor="white" />
                    <div className='mobile-contact-head-in'></div>
                </div>
                <div className='bl-form bl-form-contact'>
                    <div className="align-center logo-desc">
                        <LogoComponent logoColor="white" />
                    </div>
                    <div className='mobile-map'>
                        <Map />
                    </div>
                    <h1>{contactUsLbl}</h1>
                    <ContactForm />
                    <br />
                    <ContactAddress />
                    <ContactPhone display="block" />
                    <ContactEmail display="block" />
                    <Map />
                </div>
            </Col>
        </Row>
    </div>
    )
}

export default ContactPage;